// test380
(380 && 0);
